<template>
  <div class="explain-right-body br5">
    <div class="ex-tit fl">
      <h1>{{commonTitle}}</h1>
      <p></p>
    </div>
    <div class="ex-nr" v-html="unescapeHTML(commonArticle)"></div>
  </div>
</template>
<script>
export default {
  name: "protocol",
  metaInfo(){
    return {
      title:"用户服务协议_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  data(){
    return{
      commonTitle:"",
      commonArticle:""
    }
  },
  mounted(){
    this.queryCommonInfo();
  }, 
  methods:{
    queryCommonInfo(){
      //用户服务协议
      this.$http.get('/query_common_info?type=13', {}).then(res=>{
        if(res.data.code == 2000){
          this.commonTitle = res.data.data.common_title;
          this.commonArticle = res.data.data.common_article;
        }
      });
    },
    unescapeHTML: function(content){
      content = "" + content;
      content = content.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&").replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(new RegExp('background-color: #ffffff;','g'), "")
      .replace(new RegExp('background:rgb(255,255,255)','g'), "")
      .replace(new RegExp('background: rgb(255, 255, 255)','g'), "")
      .replace(new RegExp('background: #ffffff;','g'),"");
      content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
        let replace;
        if(capture.substr(0,7) == 'http://'){
          replace = capture;
        }else if(capture.substr(0,1) =="/"){
          replace = this.baseAddress+capture;
        }else{
          replace = this.baseAddress+"/"+capture;
        }
        return match.replace(capture,replace);
      });
      return content;
    },
  }
};
</script>
<style src="@/assets/css/explain.css" scoped></style>
<style>
  .ex-nr,.ex-nr span,.ex-nr ul{
    width: 100%;
  }

  .ex-nr span{
    color: #333;
    font-size: 16px;
    line-height: 32px;
    padding-top: 3px;
  }

  .ex-nr span{
    float: left;
  }

  .ex-nr ul{
    line-height: 28px;
  }

  .ex-nr ul li{
    font-size: 14px;
    text-indent: 2rem;
    color: #000;
  }
  .ex-nr p{
    color: #383838;
    font-size: 14px;
    width: 100%;
    line-height: 28px;
    float: left;
    text-indent: 2em;
    padding-top: 10px;
  }

  .ex-nr li a{
    text-decoration: underline;
    color: #fe5600;
    font-size: 14px;
  }
</style>